import { createMuiTheme } from '@material-ui/core/styles';
import GSK_COLORS from "./Colors";

export const dashboardTheme = createMuiTheme({
    palette: {
        primary: {
            main: GSK_COLORS.GSK_DARK_RED,
        },
        secondary: {
            main: GSK_COLORS.GSK_MEDIUM_RED,
        }
    },
    overrides: {
        MuiExpansionPanel: {
            root: {
                border: "1px solid #b7b7b7",
                boxShadow: "none",

                "&:not(:last-child)": {
                    borderBottom: 0
                },
                "&:before": {
                    display: "none"
                },
                "&$expanded": {
                    margin: "auto"
                },
                fontSize: "13px"
            },
            expanded: {}
        },
        MuiExpansionPanelSummary: {
            root: {
                marginBottom: -1,
                "&$expanded": {
                    minHeight: 56
                },
                padding: "0px 15px 0px 15px",


            },
            content: {
                "&$expanded": {
                    margin: "12px 0"
                },

            },
            expanded: {}
        },
        MuiExpansionPanelDetails: {
            root: {
                padding: "10px 15px 20px 15px"
            }
        },
        MuiTypography : {
            body1: {
                fontFamily: "inherit",
                fontSize: "inherit"
             
            }

        },
        MuiInput: {
            root: {
                fontFamily: "inherit",
                fontSize: "inherit"
            }
        },
        MuiTab: {
            root: {
              '@media (min-width: 960px)': {
                minWidth: "unset"
              }
            }
          }
    }
})

